import { render, staticRenderFns } from "./CentroTerapiasEspeciaisComponente.vue?vue&type=template&id=192eecbc&scoped=true"
import script from "./CentroTerapiasEspeciaisComponente.vue?vue&type=script&lang=js"
export * from "./CentroTerapiasEspeciaisComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroTerapiasEspeciaisComponente.vue?vue&type=style&index=0&id=192eecbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192eecbc",
  null
  
)

export default component.exports